import React, { useState, useEffect } from "react";
import { Button, Modal, Radio, Space } from "antd";
import { useSelector, useDispatch } from "react-redux";

import Api from "services/Api";
import { adminActions } from "./store";

function CommonModal() {
  const dispatch = useDispatch();
  const [defaultValue, setDefaultValue] = useState("");
  const {
    designationModalShow,
    modalType,
    designationList,
    cycleList,
    defaultUserDesignation,
    defaultUserCycle,
    Id,
    page,
    pageSize,
    appraisalFilter,
    designationFilter,
    cycleFilter,
    formStatusFilter,
    sorting,
    emailSort,
    searchText,
  } = useSelector((state) => state.admin);

  const pageNumber =
    page !== "" || typeof page !== "undefined" ? `page=${page}` : "";
  const limit =
    pageSize !== "" || typeof pageSize !== "undefined"
      ? `&limit=${pageSize}`
      : "";
  const searchData =
    searchText === "" || typeof searchText === undefined
      ? ""
      : pageNumber === "" && limit === ""
      ? `search=${searchText}`
      : `&search=${searchText}`;

  const appraisalStatus =
    appraisalFilter === "" ||
    appraisalFilter === null ||
    appraisalFilter === undefined
      ? ""
      : `&appraisalStatus=${appraisalFilter}`;
  const desigFilter =
    designationFilter === "" ||
    designationFilter === null ||
    designationFilter === undefined
      ? ""
      : `&designation=${designationFilter}`;

  const cycFilter =
    cycleFilter === "" || cycleFilter === null || cycleFilter === undefined
      ? ""
      : `&appraisalCycle=${cycleFilter}`;
  const formstatusFilter =
    formStatusFilter === "" ||
    formStatusFilter === null ||
    formStatusFilter === undefined
      ? ""
      : `&status=${formStatusFilter}`;
  const sortingByName =
    sorting === "" || sorting === null || sorting === undefined
      ? ""
      : `&sort=${sorting}`;
  const sortingByEmail =
    emailSort === "" || emailSort === null || emailSort === undefined
      ? ""
      : `&emailsort=${emailSort}`;

  const downloadOptionsList = [
    "Complete Feedback Data",
    "Rank Data",
    "Work Efforts",
  ];

  useEffect(() => {
    modalType === "Designation"
      ? setDefaultValue(defaultUserDesignation)
      : setDefaultValue(defaultUserCycle);
    modalType === "Appraisal" ? setDefaultValue(defaultUserCycle) : "";
    // console.log("Default Value", modalType, Id);
  }, [defaultUserDesignation, defaultUserCycle, modalType, Id]);

  const updatePatch = () => {
    dispatch(adminActions.updateDesignationModal(false));
    if (modalType === "Designation" || modalType === "Appraisal") {
      Api.patch(`/admin/users/?userId=${Id}`)
        .params(
          modalType === "Designation"
            ? { associateLevel: defaultValue }
            : { appraisalCycle: defaultValue }
        )
        .send((response, error) => {
          console.log("Patch Response", response);
          dispatch(
            adminActions.updateUser_Cycle_Designation({
              ...{},
              defaultCycle: "",
              defaultLevel: "",
            })
          );
          dispatch(adminActions.updateRefreshEffect((olddata) => olddata + 1));
        });
      return;
    }
    if (modalType === "AllUserDownload") {
      let phrase = "";
      if (defaultValue === "Complete Feedback Data") {
        Api.get(`/admin/downloadAllFeedback?${searchData}${appraisalStatus}${desigFilter}${cycFilter}${formstatusFilter}`).send((response, error) => {
          if (response) {
            window.open(`${response}`);
          }
          dispatch(
            adminActions.updateUser_Cycle_Designation({
              ...{},
              defaultCycle: "",
              defaultLevel: "",
            })
          );
          dispatch(adminActions.updateRefreshEffect((olddata) => olddata + 1));
        });
      }
    }
    if (defaultValue === "Rank Data") {
      let value = "download=true";
      let phrase =
        value === "" || value === null || value === undefined
          ? ""
          : `&${value}`;
      Api.get(
        `/admin/users?${searchData}${appraisalStatus}${desigFilter}${cycFilter}${formstatusFilter}${sortingByName}${sortingByEmail}${phrase}`
      ).send((response, error) => {
        if (response) {
          window.open(`${response}`);
        }
        dispatch(
          adminActions.updateUser_Cycle_Designation({
            ...{},
            defaultCycle: "",
            defaultLevel: "",
          })
        );
        dispatch(adminActions.updateRefreshEffect((olddata) => olddata + 1));
      });
    }
    if (defaultValue === "Work Efforts") {
      Api.get(`/admin/downloadTotalEffortHours?${searchData}${appraisalStatus}${desigFilter}${cycFilter}${formstatusFilter}${sortingByName}${sortingByEmail}`).send((response, error) => {
        if (response) {
          window.open(`${response}`);
        }
        dispatch(
          adminActions.updateUser_Cycle_Designation({
            ...{},
            defaultCycle: "",
            defaultLevel: "",
          })
        );
        dispatch(adminActions.updateRefreshEffect((olddata) => olddata + 1));
      });
    }
    setDefaultValue("");
  };

  const onCancel = () => {
    dispatch(adminActions.updateDesignationModal(false));
    dispatch(
      adminActions.updateUser_Cycle_Designation({
        ...{},
        defaultCycle: "",
        defaultLevel: "",
      })
    );
    setDefaultValue("");
  };

  const designationValue = () => (
    <Space style={{ marginTop: "0.5rem" }} direction="vertical">
      {Object.values(designationList).map((val, index) => (
        <Radio key={index} value={val}>
          {val}
        </Radio>
      ))}
    </Space>
  );

  const appraisalValue = () => (
    <Space style={{ marginTop: "1.5rem" }} direction="vertical">
      {Object.values(cycleList).map((val, index) => (
        <Radio key={index} value={val}>
          {val}
        </Radio>
      ))}
    </Space>
  );

  const downloadOptions = () => (
    <Space style={{ marginTop: "0.5rem" }} direction="vertical">
      {downloadOptionsList.map((val, index) => (
        <Radio key={index} value={val}>
          {val}
        </Radio>
      ))}
    </Space>
  );

  const valueOnChange = (e) => {
    if (modalType === "Designation" || modalType === "Appraisal") {
      setDefaultValue(e.target.value);
    }
    if (modalType === "AllUserDownload") {
      setDefaultValue(e.target.value);
    }
  };

  return (
    <Modal
      visible={designationModalShow}
      title={false}
      bodyStyle={{ height:modalType === "AllUserDownload" ? "30vh" : "35vh"  }}
      onOk={updatePatch}
      footer={
        modalType === "AllUserDownload"
          ? [
              <Button
                onClick={updatePatch}
                type="primary"
                style={{ width: "8rem", height: "2.5rem" }}
                disabled={defaultValue === ""}
              >
                Download
              </Button>,
            ]
          : [
              <Button
                onClick={onCancel}
                style={{
                  width: "8rem",
                  height: "2.5rem",
                  marginRight: "1rem",
                }}
                size="large"
              >
                Cancel
              </Button>,
              <Button
                size="large"
                onClick={updatePatch}
                type="primary"
                style={{
                  width: "8rem",
                  height: "2.5rem",
                }}
              >
                OK
              </Button>,
            ]
      }
      onCancel={onCancel}
    >
      <div style={{ marginTop: "1rem" }}>
        {modalType === "Designation" ? (
          <h3 style={{ fontFamily: "Roboto-Bold" }}>Associate Level</h3>
        ) : modalType === "Appraisal" ? (
          <h3 style={{ fontFamily: "Roboto-Bold" }}>Appraisal Cycle</h3>
        ) : (
          <h3 style={{ fontFamily: "Roboto-Bold" }}>Download User Data</h3>
        )}
        {modalType === "Designation" ? (
          <div style={{ fontFamily: "Roboto-Italic" }}>
            Change level of Associate
          </div>
        ) : modalType === "Appraisal" ? (
          <div style={{ fontFamily: "Roboto-Italic" }}>
            Change the appraisal cycle for the Employee
          </div>
        ) : (
          ""
        )}
      </div>
      <div
        style={{
          height: modalType === "AllUserDownload" ? "15vh" : "20vh",
          display: "flex",
          alignItems: "flex-start",
        }}
      >
        <Radio.Group value={defaultValue} onChange={valueOnChange}>
          {modalType === "Designation"
            ? designationValue()
            : modalType === "Appraisal"
            ? appraisalValue()
            : downloadOptions()}
        </Radio.Group>
      </div>
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        {console.log("Selected option", defaultValue)}
      </div>
    </Modal>
  );
}

export default CommonModal;
